import React, { Component } from 'react';
import { PlayStoreButton } from '../Button';

class Footer extends Component {
	constructor(props) {
		super(props);
		this.state = {};
		console.log('FFFFFooter')
	}

	render() {
		return (
			<footer className="footer-area">
				<div className="container">
					{/*<div className="row">*/}
					{/*	<div className="col-lg-3 col-sm-6 col-md-6">*/}
					{/*		<div className="single-footer-widget">*/}
					{/*			<h4 className="text-uppercase">About HALASZ</h4>*/}
					{/*			<ul className="footer-lists">*/}
					{/*				<li>*/}
					{/*					<a href="/">For Business</a>*/}
					{/*				</li>*/}
					{/*				<li>*/}
					{/*					<a href="/">Premium Plans</a>*/}
					{/*				</li>*/}
					{/*				<li>*/}
					{/*					<a href="/">How it Works</a>*/}
					{/*				</li>*/}
					{/*				<li>*/}
					{/*					<a href="/">Halasz Blog</a>*/}
					{/*				</li>*/}
					{/*			</ul>*/}
					{/*		</div>*/}
					{/*	</div>*/}
					{/*	<div className="col-lg-3 col-sm-6 col-md-6">*/}
					{/*		<div className="single-footer-widget">*/}
					{/*			<h4 className="text-uppercase">Company</h4>*/}
					{/*			<ul className="footer-lists">*/}
					{/*				<li>*/}
					{/*					<a href="/">Product Tour</a>*/}
					{/*				</li>*/}
					{/*				<li>*/}
					{/*					<a href="/">Pricing</a>*/}
					{/*				</li>*/}
					{/*				<li>*/}
					{/*					<a href="/">Founding Members</a>*/}
					{/*				</li>*/}
					{/*				<li>*/}
					{/*					<a href="/">Product Updates</a>*/}
					{/*				</li>*/}
					{/*			</ul>*/}
					{/*		</div>*/}
					{/*	</div>*/}
					{/*	<div className="col-lg-3 col-sm-6 col-md-6">*/}
					{/*		<div className="single-footer-widget">*/}
					{/*			<h4 className="text-uppercase">Support</h4>*/}
					{/*			<ul className="footer-lists">*/}
					{/*				<li>*/}
					{/*					<a href="/">Documentation</a>*/}
					{/*				</li>*/}
					{/*				<li>*/}
					{/*					<a href="/">Data Securiry</a>*/}
					{/*				</li>*/}
					{/*				<li>*/}
					{/*					<a href="/">Site Performance</a>*/}
					{/*				</li>*/}
					{/*				<li>*/}
					{/*					<a href="/">Resources</a>*/}
					{/*				</li>*/}
					{/*			</ul>*/}
					{/*		</div>*/}
					{/*	</div>*/}
					{/*	<div className="col-lg-3 col-sm-6 col-md-6">*/}
					{/*		<div className="single-footer-widget">*/}
					{/*			<h4 className="text-uppercase">Legal</h4>*/}
					{/*			<ul className="footer-lists">*/}
					{/*				<li>*/}
					{/*					<a href="/">Terms and conditions</a>*/}
					{/*				</li>*/}
					{/*				<li>*/}
					{/*					<a href="/">Privacy Policy</a>*/}
					{/*				</li>*/}
					{/*				<li>*/}
					{/*					<a href="/">Opt - Out</a>*/}
					{/*				</li>*/}
					{/*			</ul>*/}
					{/*		</div>*/}
					{/*	</div>*/}
					{/*</div>*/}
					<div className="row">
						<div className="col-lg-12">
							<div className="footer-logo">
								<a href="index.html">
									<img src={require('../../assets/img/logo_2.png')} alt="" />
								</a>
							</div>
						</div>
					</div>
					<div className="row copyright-area relative">
						<div className="col-lg-6 col-md-4">
							<p className="copy-right-text">
								Copyright © 2019 All rights reserved to <a href="/">HALASZ</a>
							</p>
						</div>
						<div className="col-lg-6 col-md-8">
							<PlayStoreButton />
						</div>
					</div>
				</div>
			</footer>
		);
	}
}

export default Footer;
